import * as Data$dUUID from "../Data.UUID/index.js";
const newIdGenerator = dict => dict.newIdGenerator;
const generateUUID = {newIdGenerator: () => () => Data$dUUID._genUUIDImpl()};
export {generateUUID, newIdGenerator};
